import React from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingCTA() {
  return <section id="pricing" className="py-16 md:py-24 bg-white relative" data-id="element-131">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="bg-sage-dark rounded-[2.5rem] p-8 md:p-12 text-center text-white relative overflow-hidden shadow-2xl" data-id="element-133">
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-10 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmYiLz48L3N2Zz4=')]" data-id="element-134"></div>

          <div className="relative z-10" data-id="element-135">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 font-heading" data-id="element-136">
              Comienza tu transformación hoy
            </h2>

            <p className="text-lg md:text-xl text-sage-light mb-8 max-w-2xl mx-auto" data-id="element-137">
              Recupera tu agilidad hoy mismo por un precio único de lanzamiento.
              No es una suscripción mensual, es una inversión única en tu salud
              y bienestar futuro.
            </p>

            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 max-w-md mx-auto mb-8 border border-white/20" data-id="element-138">
              <div className="inline-block bg-gold/20 text-gold font-bold text-sm uppercase tracking-wider px-4 py-1.5 rounded-full mb-4" data-id="element-139">
                🔥 Oferta de Lanzamiento — 60% OFF
              </div>
              <p className="text-sage-light font-medium uppercase tracking-wider text-sm mb-3" data-id="element-140">
                Inversión Única
              </p>
              <div className="flex justify-center items-baseline gap-4" data-id="element-141">
                <span className="text-2xl text-white/40 line-through" data-id="element-142">$16</span>
                <div className="flex items-start gap-1" data-id="element-143">
                  <span className="text-3xl font-bold mt-2 text-gold" data-id="element-144">$</span>
                  <span className="text-7xl font-bold text-gold" data-id="element-145">6.39</span>
                </div>
              </div>
              <p className="text-sm text-sage-light mt-4 flex items-center justify-center gap-2" data-id="element-146">
                <Lock size={16} data-id="element-147" /> Pago 100% seguro
              </p>
            </div>

            <a id="pricing-cta" href="https://www.guiasparavivir.com/cart/52429326680353:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-block w-full sm:w-auto px-10 py-5 bg-gold hover:bg-[#b39154] text-white font-bold text-xl rounded-full shadow-lg transition-all transform hover:-translate-y-1 hover:shadow-xl mb-6 text-center" data-id="element-148">
              ¡SÍ, QUIERO RECUPERAR MI MOVILIDAD!
            </a>

            <div className="flex items-center justify-center gap-2 text-sage-light text-sm" data-id="element-149">
              <ShieldCheck size={18} className="text-gold" data-id="element-150" />
              <span data-id="element-151">Acceso inmediato tras tu compra. Formato PDF digital.</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}